import React from 'react';
import { Handle, Position } from '@xyflow/react';

// Nó de texto do editor de Guia Marni. Em modo de edição, título e corpo são
// campos editáveis inline; em modo de visualização, vira somente leitura.
export default function TextNode({ id, data }) {
  const readOnly = Boolean(data?.readOnly);

  return (
    <div className={`gm-flow-node${data?.accent ? ` gm-flow-node-${data.accent}` : ''}`}>
      <Handle type="target" position={Position.Top} />
      <Handle type="target" position={Position.Left} id="left" />
      {!readOnly && (
        <button type="button" className="gm-flow-node-delete" title="Excluir nó" aria-label="Excluir nó" onMouseDown={(event) => event.stopPropagation()} onClick={() => data.onDelete?.(id)}>×</button>
      )}
      <input
        className="gm-flow-node-title"
        value={data?.title || ''}
        placeholder="Título"
        readOnly={readOnly}
        onChange={(event) => data.onChange?.(id, { title: event.target.value })}
        onMouseDown={(event) => event.stopPropagation()}
      />
      <textarea
        className="gm-flow-node-body"
        value={data?.body || ''}
        placeholder="Descreva este passo do guia..."
        readOnly={readOnly}
        rows={3}
        onChange={(event) => data.onChange?.(id, { body: event.target.value })}
        onMouseDown={(event) => event.stopPropagation()}
      />
      <Handle type="source" position={Position.Bottom} />
      <Handle type="source" position={Position.Right} id="right" />
    </div>
  );
}
